import React from 'react';
import { CheckIcon, CreditCardIcon, DownloadIcon, InfinityIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { offerRows } from '../../data/content';
const guarantees = [{
  icon: DownloadIcon,
  label: 'Instant Download'
}, {
  icon: InfinityIcon,
  label: 'Lifetime Access'
}, {
  icon: CreditCardIcon,
  label: 'One-Time Payment'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}];
export function Offer() {
  return <section id="offer" className="w-full bg-cream px-4 py-12 sm:py-16" data-id="element-182" data-mp="3f2ffks8rmdgy">
      <div className="mx-auto max-w-2xl" data-id="element-183" data-mp="3jwjqfml5j5nb">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.22em] text-alert" data-id="element-184" data-mp="3nwu3tkb9wyc7">
          🔥 Special Launch Offer
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-black leading-tight text-navy-deep sm:text-4xl" data-id="element-185" data-mp="3sx9fm7fwpxs2">
          You’re Not Just Buying a PDF.
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-[15px] font-medium leading-relaxed text-ink/70 sm:text-lg" data-id="element-186" data-mp="1klzu9b2kzqlr">
          You’re getting a complete Clinical Pathway for obesity management that you can return to
          whenever you have a patient in front of you.
        </p>

        <div className="mt-8 overflow-hidden rounded-3xl border border-navy/12 bg-white" data-id="element-187" data-mp="16lyr1oyug734">
          <div className="flex items-center justify-between gap-3 bg-navy-deep px-5 py-3" data-id="element-188" data-mp="23bya4dcmenzy">
            <span className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-white/80" data-id="element-189" data-mp="23dsp7b17nlw4">
              What you get today
            </span>
            <span className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-white/80" data-id="element-190" data-mp="1uicxp0nxhitp">
              Value
            </span>
          </div>
          <ul data-id="element-191" data-mp="2mzyq6xpv7spb">
            {offerRows.map(row => <li key={row.label} className="flex items-start justify-between gap-4 border-b border-navy/8 px-5 py-3.5 last:border-0" data-id="element-192" data-mp="2n1i6upffo5rm">
                <span className="flex gap-2 text-[14px] font-semibold leading-snug text-ink/80" data-id="element-193" data-mp="316iioj1r2kfz">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest-mid" aria-hidden="true" data-id="element-194" data-mp="363ioqtylnn73" />
                  {row.label}
                </span>
                <span className="shrink-0 text-[14px] font-bold text-ink/50 line-through" data-id="element-195" data-mp="2wer0owwntn1g">
                  {row.value}
                </span>
              </li>)}
          </ul>
          <div className="flex items-center justify-between gap-4 bg-cream-dark px-5 py-3.5" data-id="element-196" data-mp="2ihc85jb40z59">
            <span className="text-[13px] font-extrabold uppercase tracking-wider text-navy-deep" data-id="element-197" data-mp="2nbzp8x3sar9t">
              Total value
            </span>
            <span className="font-display text-xl font-black text-navy-deep" data-id="element-198" data-mp="2df4pkavrykty">$282</span>
          </div>

          <div className="border-t border-navy/10 px-5 py-7 text-center" data-id="element-199" data-mp="7moiu38lghfo">
            <p className="text-[12px] font-extrabold uppercase tracking-[0.16em] text-ink/55" data-id="element-200" data-mp="bo9rtdi0cbkl">
              Today you can get full access for just
            </p>
            <div className="mt-3 flex items-end justify-center gap-3" data-id="element-201" data-mp="1w6u3p1fxmmvo">
              <span className="font-display text-2xl font-bold text-ink/40 line-through" data-id="element-202" data-mp="1s6a3tq3z555u">$282</span>
              <span className="font-display text-5xl font-black leading-none text-forest sm:text-6xl" data-id="element-203" data-mp="25x5hrgtbycga">
                $27
              </span>
              <span className="pb-1 text-sm font-extrabold text-forest" data-id="element-204" data-mp="213u5v19nv5hi">USD</span>
            </div>
            <p className="mx-auto mt-3 max-w-sm text-[13px] font-medium text-ink/65" data-id="element-205" data-mp="2fwe8m0swfayf">
              One-time payment. No monthly fees. No recurring charges. Lifetime access.
            </p>
            <p className="mx-auto mt-2 max-w-sm rounded-xl bg-cream px-3 py-2 text-[12px] font-semibold text-ink/70" data-id="element-206" data-mp="2ot58ypehhbyt">
              💱 Currency conversion is automatically applied according to your country.
            </p>

            <div className="mt-6" data-id="element-207" data-mp="pidlutwz6n28">
              <CTAButton label="I want the Clinical Kit now" data-id="element-208" data-mp="pjfbc3eqnc3h" />
            </div>

            <div className="mt-6" data-id="element-209" data-mp="rxk6bbevsbqd">
              <Countdown data-id="element-210" data-mp="rw95nkgqfk3h" />
            </div>

            <div className="mt-6" data-id="element-211" data-mp="vy43ug3d9hd1">
              <ScarcityBar data-id="element-212" data-mp="vx2pa1n56cqk" />
            </div>

            <ul className="mt-6 grid grid-cols-2 gap-3" data-id="element-213" data-mp="10xh01rg4o0sa">
              {guarantees.map(item => <li key={item.label} className="flex items-center gap-2 rounded-xl bg-cream px-3 py-2.5 text-left" data-id="element-214" data-mp="15wjt0diu2gjw">
                  <item.icon className="h-4 w-4 shrink-0 text-forest-mid" aria-hidden="true" data-id="element-215" data-mp="8amgcwr4x5fv" />
                  <span className="text-[12px] font-bold leading-tight text-ink/75" data-id="element-216" data-mp="d85uzxrqvk8c">
                    {item.label}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}